import { observable } from 'mobx'

export default class FormStore {
    errors = observable.map({})

    formValidations = {}

    name = 'name'

    register = (name, validate) => {
        this.formValidations[name] = validate
    }

    unregister = (name) => {
        Reflect.deleteProperty(this.formValidations, name)
    }

    setValid = (name, isValid) => {
        if (isValid) {
            this.errors.delete(name)
        } else {
            this.errors.set(name, true)
        }
    }
}
